import { z } from 'zod';

import { zodAddUnitMappingSchema } from '../useMutationAddUnitMapping';

export const zodUpdateUnitMappingSearchParamsSchema = zodAddUnitMappingSchema;

export const zodUpdateUnitMappingSchema = z.object({
  unitMappingId: z.uuid(),
  unitMappingData: zodUpdateUnitMappingSearchParamsSchema,
});

export const zodUpdateUnitMappingEndpointSchema = z.tuple([
  z.literal('units'),
  z.literal('unit_mapping'),
  z.uuid(),
]);
